import { render, staticRenderFns } from "./WorkSuccessGates.vue?vue&type=template&id=4f889f5a&"
import script from "./WorkSuccessGates.vue?vue&type=script&lang=js&"
export * from "./WorkSuccessGates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports